import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';

import {
  postUpload,
  type PostUploadParams,
  type PostUploadResponse,
} from '@services/FilesService';

export type UsePostUploadParams = {
  mutationOptions?: SWRMutationConfiguration<
    PostUploadResponse,
    unknown,
    string,
    PostUploadParams,
    PostUploadResponse
  >;
};

export const postUploadMutationKey = 'post-upload';

export const usePostUpload = ({
  mutationOptions,
}: UsePostUploadParams = {}) => {
  const { trigger, ...swrResponse } = useSWRMutation<
    PostUploadResponse,
    unknown,
    string,
    PostUploadParams
  >(postUploadMutationKey, (_url, { arg }) => postUpload(arg), mutationOptions);

  return {
    trigger,
    ...swrResponse,
  };
};
